

// function to check window.Awtomic.subscriptionBillingAttempts and if the length is < 2 then hide any element with .bundle-button--pause and .bundle-button--cancel and .bundle-button--skip and frequency changes
var configureCustomerPortal = () => {
    if (window.Awtomic.subscriptionBillingAttempts.length < 2) {
        document.querySelectorAll('.bundle-button--pause').forEach((el) => {
            el.style.display = 'none';
        });
        document.querySelectorAll('.bundle-button--cancel').forEach((el) => {
            el.style.display = 'none';
        });
        document.querySelectorAll('.bundle-button--skip').forEach((el) => {
            el.style.display = 'none';
        });
        document.querySelectorAll('.awt-nbd-code-container button.bundleapp-btn--text').forEach((el) => {
            el.style.display = 'none';
        });
        document.querySelectorAll('.bundle-card--edit-frequency .bundle-card__button').forEach((el) => {
            el.style.display = 'none';
        });
        document.querySelectorAll('.bundle-card--next-order-date .bundle-card__button').forEach((el) => {
            el.style.display = 'none';
        });
    }
};

window.addEventListener('awtomic-cp-loaded', () => {
    setTimeout(configureCustomerPortal, 200);
    setTimeout(mountGiftBanner, 200); // uncomment to show gift banner
});


/**** */

/** Code to add custom banner to the BaB Create/Edit UI ***/
let checkAndInsertElement = function () {
    // Check if URL path is in the expected format
    let urlPattern = /^\/tools\/bundle-subscriptions\/bundle\/\d+$/;
    let pathIsValid = urlPattern.test(window.location.pathname);

    let headerElement = document.querySelector('.awtomatic-sizes-container');
    let existingDescription = document.getElementById('awt-bab-description');

    if (pathIsValid && headerElement && !existingDescription) {
        let divElement = document.createElement('div');
        divElement.id = 'awt-bab-description';
     //   divElement.innerHTML = `<h2 style="margin-bottom: 10px;">Build your own box</h2>Select your own flavors! Up to 3 flavors if you're selecting a one dozen or 6 flavors for a two dozen. Sending cookies as a gift? We always consolidate the cookies into the fewest number of gifts boxes, but if you need them separated into separate gift boxes to hand out as gifts AND you are shipping to one location, please email us at <a href="info@thecravory.com">info@thecravory.com</a>. Due to shipping restraints, there may be an additional charge.`;
        divElement.innerHTML = `<h2 style="margin-bottom: 10px;">Build your own box</h2>`;

        headerElement.prepend(divElement);
    }
};

let intervalID;

let urlPattern = /^\/tools\/bundle-subscriptions\/bundle.*/;
let pathIsBaB = urlPattern.test(window.location.pathname);
if (pathIsBaB) {
    intervalID = setInterval(checkAndInsertElement, 50); // Checking every second
}
/** END Code to add custom banner to the BaB Create/Edit UI ***/

// BAB slideout cart
// when the window loads, if the url has the param `opencart` then open the cart
window.addEventListener('load', function () {
    let url = new URL(window.location.href);
    let openCart = url.searchParams.get('opencart');
    if (openCart) {
        // find .shopify-section--header a[href="/cart"] and click it
        let cartButton = document.querySelector('.shopify-section--header a[href="/cart"]');
        if (cartButton) {
            cartButton.click();
        }
    }
});
function redirectOverride({ cartItems, discountCode }) {
    //refresh the page to the same location but add the param `opencart` to the url
    let url = new URL(window.location.href);
    url.searchParams.set('opencart', 'true');
    window.location.href = url.href;
}
window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
    bab: {
        ...(window.bundleapp.settings.bab || {}),
        addToCartRedirect: redirectOverride,
        productImage: 600,
    },
});
// End BAB slideout cart



/*** Script to add ship date to CP ***/

if (
    window.location.pathname.includes('tools/bundle-subscriptions') &&
    new URLSearchParams(window.location.search).get('subscriptionId')
) {
    // Function to check for the Awtomic object and attribute
    function checkForAwtomic() {
        if (window.Awtomic && window.Awtomic.subscriptionDetails) {
            var customAttribute = window.Awtomic.subscriptionDetails.CustomAttributes.find(
                (attr) => attr.key === 'dateShip'
            );

            if (customAttribute) {
                var dateValue = new Date(customAttribute.value);
                var today = new Date();

                if (dateValue > today) {
                    // Reformat the date as required
                    var formattedDate =
                        (dateValue.getMonth() + 1).toString() +
                        '/' +
                        dateValue.getDate().toString() +
                        '/' +
                        dateValue.getFullYear();

                    // Create the new div element
                    var divElement = document.createElement('div');
                    divElement.style.cssText =
                        'padding: 7px 10px;background: var(--primary-btn-bg-color);color: #fff;width: auto;display: inline-block;text-align: center;font-weight: bold;';
                    divElement.innerHTML = 'Ship Date • ' + formattedDate;

                    // Find the target div and insert the new div before it
                    var targetDiv = document.querySelector('div.bundle-card--next-order-date');
                    if (targetDiv) {
                        targetDiv.parentNode.insertBefore(divElement, targetDiv);
                    }
                }
            }
        } else {
            // If the Awtomic object doesn't exist yet, wait and check again
            setTimeout(checkForAwtomic, 100);
        }
    }

    // Start the check
    checkForAwtomic();
}

/*** End Script to add ship date to CP ***/